import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "http://localhost:2000";

export default {
    actions: {
        addNotification({}, payload) {
            return new Promise(async (resolve, reject) => {
              try {
                let urlResponse = await axios.post(`${BASE_URL}/notifications/adminPanel`, payload);
                if (urlResponse.data.status=='success') {
                  resolve("success");
                } else {
                  throw('adding notifications failed!');
                }
              } catch(err) {
                  reject(err);
              }
            });
          },
          getAllNotification() {
            return new Promise(async (resolve, reject) => {
              try {
                let urlResponse = await axios.get(`${BASE_URL}/notifications/adminPanel`);
                if (urlResponse.data.status=='success') {
                  resolve(urlResponse.data.data);
                } else {
                  throw('getting notifications failed!');
                }
              } catch(err) {
                  reject(err);
              }
            });
          },
          fetchAllTemplate() {
            return new Promise((resolve,reject) => {
              axios.get(`${BASE_URL}/notifications/template/listing`).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
          createTemplate({}, template_payload) {
            return new Promise((resolve,reject) => {
              axios.post(`${BASE_URL}/notifications/create/template`,template_payload).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
          sendTemplateTestEmail({}, template_payload) {
            return new Promise((resolve,reject) => {
              axios.post(`${BASE_URL}/notifications/admin/templates/send/test`,template_payload).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
          sendTemplateBulkEmail({}, template_payload) {
            return new Promise((resolve,reject) => {
              axios.post(`${BASE_URL}/notifications/admin/templates/send/bulk`,template_payload).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
          getTemplateDetails({}, templateId) {
            return new Promise((resolve,reject) => {
              axios.get(`${BASE_URL}/notifications/fetch/template/${templateId}`).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
          fetchTemplateQueue({}, templateId) {
            return new Promise((resolve,reject) => {
              axios.get(`${BASE_URL}/notifications/fetch/queue/${templateId}`).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
          fetchEventmembers({}, eventId) {
            return new Promise((resolve,reject) => {
              axios.get(`${BASE_URL}/events/finals/qualified-members/${eventId}`).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
          fetchFilteredAudience({}, payload) {
            return new Promise((resolve,reject) => {
              axios.post(`${BASE_URL}/notifications/fetch-filtered-audience`,payload).then((response) => {
                resolve(response.data.data)
              }).catch(error => {
                reject(error.response.data)
              })
            })
          },
    }
};